// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
import axios                from 'axios'
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';

var url                     = "https://app.osis.app.br";
Vue.use(VueRouter)
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
window.axios                = axios
axios.defaults.baseURL      = url;
Vue.config.productionTip    = false
window._app;
Vue.config.ignoredElements = [/^ion-/]

if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
if (window.cordova || location.hostname != "localhost") {
    axios.defaults.timeout  = 60000;
}

axios.interceptors.request.use((config) => {
    if (config.baseURL == url && window.__app.logged && config.authentication) {

        if (config.method == "post" || config.method == "put") {
            config.data._cod    = window.__app.user.cod;
            config.data._token  = window.__app.user.token;
        } else if (config.method == "get" || config.method == "delete") {
            config.params._cod    = window.__app.user.cod;
            config.params._token  = window.__app.user.token;
        }
    }

    return config;
});

Vue.filter('nl2br', function (str) {
    return str.replaceAll('\\n', '<br/>');
});

/* eslint-disable no-new */
new Vue({
    el:                  '#app',
    router,
    components: {
        App
    },
    template:            '<App/>',

    data: {
        "ready":        false,
        "logged":       false,
        "cordova":      window.cordova || null,
        "user":  {
            "cod":      null,
            "token":    null,
            "nome":     null,
            "tipo":     "contratante"
        },
        "mobile":       mobile,
        "tmp":  {
        },
        "modal": {
        },
        "avaliacao":            null,
        "formAvaliacao": {
            "_cod":             "",
            "_token":           "",
            "texto":            "",
            "nota":             null,
            "cod":              "",
        },                    
        "curriculo": {
            "descricao":        ""
        },
        "cacheDefault": {
            "inicioCatalogo": {
                "filtro":   null,
                "data":     null,
            },
            "inicioPrestadores": {
                "filtro":   null,
                "data":     null,
            },  
            "inicioPendentes": {
                "filtro":   null,
                "data":     null,
            },                        
            "catalogo": {
                "filtro":   null,
                "data":     null,
            },
            "prestadores": {
                "filtro":   null,
                "data":     null,
            },            
            "categorias": {
                "data":     null
            }
        },
        "cache":        {
            "inicioCatalogo": {
                "filtro":   null,
                "data":     null,
            },
            "inicioPrestadores": {
                "filtro":   null,
                "data":     null,
            },       
            "inicioPendentes": {
                "filtro":   null,
                "data":     null,
            },         
            "prestadores": {
                "filtro":   null,
                "data":     null,
            },                                                        
            "catalogo": {
                "filtro":   null,
                "data":     null,
            },
            "categorias": {
                "data":     null
            }            
        },   
        "internet":      {
            "online":   true  
        },      
        "config": {
            "url":      url,
            "nome":     "Osis",
            "titulo":   "Osis Consultas e Exames",
            "googleAnalytics": {
                "id":   ""
            },
            "pusher": {
                "key": "14f53c59b79d357eee49"
            },  
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            }                
        },
        "realtime": {},
        "chamada": null,      
        "chamadaMute": {
            "audio": false,
            "video": false,
        },
        "chamadaRoom": null,  
        "teleconsulta": null,
        "modalTeleconsulta": false,        
        "memed": {
            "loaded": false
        }
    },
    methods: {
        initialize: function() {
            console.log("app.initialize()");
            var self             = this;

            gtag('js', new Date());
            gtag('config', self.config.googleAnalytics.id);

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            var login       = self.checkLogin();
            self.fixClass();


            Pusher.logToConsole     = false;
            self.realtime.client    = new Pusher(self.config.pusher.key, {
                cluster:            'mt1',
                activityTimeout:    2000,
                enabledTransports:  ['ws']
            });
            self.realtime.client.connection.bind('state_change', function(states) {
                states = {previous: 'oldState', current: 'newState'}
                console.log("PUSHER >>>>> Channels current state is ", states);
            });   
                   
        },
        setModalTeleconsulta(status) {
            console.log("setModalTeleconsulta()", status);
            this.modalTeleconsulta = status;
            if (status == "closed" || status == "opened") {
                $(".modal-teleconsulta").attr("style", "");
            }
            if (status == "closed") {
                $(".modal-teleconsulta").resizable("option", "disabled", true );
                $(".modal-teleconsulta").resizable("option", "handles", "" );
                $(".modal-teleconsulta").resizable("option", "helper", "" );
                
            } else {
                $(".modal-teleconsulta").resizable("option", "disabled", false );
                $(".modal-teleconsulta").resizable("option", "helper", "ui-resizable-handle" );
            }
            this.$forceUpdate();
        },        
        closeTeleconsulta: function() {
            var self = this;
            console.log("closeTeleconsulta()");
            if (window.__track) window.__track.stop();
            if (window.__room) window.__room.disconnect();

            $("#remote-media").html("");
            $("#local-media").html("");

            self.chamada = null;
            // self.realtime.client.disconnect();
            // self.realtime = {};
            self.$forceUpdate();
            self.setModalTeleconsulta(false);
            if (window.twiliovideo) window.twiliovideo.closeRoom();              
        },            
        initTeleconsultaVideo: function(token, room) {
            var self        = this;
            console.log("initTeleconsultaVideo()", token, room);
            if (self.chamada) return false;

            self.chamada    = {
                "token":    token,
                "room":     room
            };

            self.$forceUpdate();

            window.__chamada = self.chamada;

            self.setModalTeleconsulta("opened");

            setTimeout(function() {
                $(".modal-teleconsulta").draggable({
                    start: function() {
                      
                    },
                    drag: function() {
                        // console.log("drag event");
                        $(".modal-teleconsulta").addClass("dragged");
                    },
                    stop: function() {
                      
                    }
                });
                $( ".modal-teleconsulta" ).resizable({
                    minHeight: 525,
                    minWidth: 500,
                    maxHeight: $(window).height() - 100,
                    maxWidth: $(window).width() - 100,
                    handles: "all",
                    resize: function( event, ui ) {
                        console.log("resize()", event, ui.size.height)

                        // if (self.modalTeleconsulta == "closed") {
                        //     console.log("está fechado, ignora")
                        //     event.preventDefault();
                        //     return false;
                        // }

                        var size = (ui.size.height - 200) + "px";
                        // console.log("size>", size)
                        $(".chamada-video").height(size);
                    }
                });
            }, 500);

            setTimeout(function () {

                var Video = Twilio.Video;
                Video.createLocalVideoTrack().then(track => {
                    var localMediaContainer = document.getElementById('local-media');
                    window.__track = track;
                    localMediaContainer.appendChild(track.attach());
                });

                Video.connect(token, {
                    name:           room,
                    bundlePolicy:   'max-compat'
                }).then(room => {
                    console.log(`Successfully joined a Room: ${room}`);

                    loading.hide();

                    self.room   = room;
                    window.__room = room;
                    // _room       = room;

                    var remoteMediaContainer = document.getElementById('remote-media');
                        room.participants.forEach(function(participant) {
                        console.log("Already in Room: '" + participant.identity + "'");
                        participantConnected(participant, remoteMediaContainer);
                    });

                    room.on('participantConnected', participant => {
                        console.log(`A remote Participant connected: ${participant}`);
                        participantConnected(participant);
                    });

                    room.on('participantDisconnected', participant => {
                        console.log(`A remote Participant connected: ${participant}`);
                        participantDisconnected(participant);
                    });

                }, error => {
                    loading.hide();
                    console.error(`Unable to connect to Room: ${error.message}`);
                });

                function participantConnected(participant) {
                    console.log('Participant "%s" connected', participant.identity);
                    const div   = document.createElement('div');
                    div.id      = participant.sid;
                    participant.on('trackSubscribed', (track) => {
                        trackSubscribed(div, track)
                    });
                    participant.on('trackUnsubscribed', trackUnsubscribed);
                    participant.tracks.forEach(publication => {
                        if (publication.isSubscribed) {
                            trackSubscribed(div, publication.track);
                        }
                    });

                    document.getElementById('remote-media').appendChild(div);
                }

                function participantDisconnected(participant) {
                    console.log('Participant "%s" disconnected', participant.identity);

                    var div     = document.getElementById(participant.sid)
                    if (div) {
                        div.remove();
                    }
                }

                function trackSubscribed(div, track) {
                    div.appendChild(track.attach());
                }

                function trackUnsubscribed(track) {
                    track.detach().forEach(element => element.remove());
                }
            }, 500);

        },         
        initRealtimeTeleconsulta: function(pedido) {
            console.log("initRealtimeTeleconsulta()", pedido)
            var self                = this;
            self.setTeleconsulta(pedido);

            console.log("initRealtimeTeleconsulta()", pedido.cod);
            self.realtime.channelPedido    = self.realtime.client.subscribe("pedidos-" + pedido.cod);
            self.realtime.channelPedido.bind("update", function(data) {
                console.log("atualizacao no pedido", data);

                self.setTeleconsulta(data.pedido);
                
            });    

            self.realtime.channelTeleconsulta   = self.realtime.client.subscribe("chamada-" + pedido.cod + "-" + self.$root.user.cod);
            self.realtime.channelTeleconsulta.bind("update", function(data) {
                console.log("atualizacao na chamada", data);
                if (data.tipo == "token") {
                    self.initTeleconsultaVideo(data.token, data.room);
                }
                if (data.tipo == "fim") {
                }
            });             
        },
        muteAudio: function() {
            var self = this;
            if (!self.chamadaMute.audio) {
                self.room.localParticipant.audioTracks.forEach((publication) => { 
                    publication.track.disable(); 
                });
                self.chamadaMute.audio = true;
            } else {
                self.room.localParticipant.audioTracks.forEach((publication) => { 
                    publication.track.enable(); 
                });                 
                self.chamadaMute.audio = false;
            }
            self.$forceUpdate();
        },
        muteVideo: function() {
            var self = this;
            if (!self.chamadaMute.video) {
                self.room.localParticipant.videoTracks.forEach((publication) => { 
                    publication.track.disable(); 
                });
                self.chamadaMute.video = true;
            } else {
                self.room.localParticipant.videoTracks.forEach((publication) => { 
                    publication.track.enable(); 
                });                 
                self.chamadaMute.video = false;
            }
            self.$forceUpdate();
        },             
        setTeleconsulta: function(pedido) {
            console.log("setTeleconsulta()", pedido);
            var self = this;
            self.teleconsulta = JSON.parse(JSON.stringify(pedido));
            self.$forceUpdate();
            if (self.$root.setPedido) self.$root.setPedido(pedido);

            if (pedido.status == 4 && self.chamada) {
                console.log("Fim teleconsulta")
                self.closeTeleconsulta();  
            }

        },    
        menu: function() {
            var self = this;
            console.log("menu");
            window.___app.dialog.create({
                title: 'Osis',
                text: '',
                buttons: [
                    {
                        text: 'Minha conta',
                        onClick: function() {
                            self.$root.go("Conta");
                        }
                    },
                    {
                        text: 'Alterar senha',
                        onClick: function() {
                            self.$root.go("AlterarSenha");
                        }
                    },             
                    {
                        text: 'Fale conosco',
                        onClick: function() {
                            self.$root.go("Contato");
                        }
                    },
                    {
                        text: 'Termos de uso',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-termos-de-uso');
                            }, 500);
                        }
                    },      
                    {
                        text: 'Políticas de privacidade',
                        onClick: function() {
                            loading.show();
                            setTimeout(function() {
                                self.$root.openModal('modal-politicas-de-privacidade');
                            }, 500);
                            
                        }
                    },   
                    {
                        text: 'Deslogar',
                        onClick: function() {
                            self.$root.logout();
                        }
                    },                                                            
                    {
                        text: '<span style="color: red; font-weight: 200">Voltar<span>',
                    },                                                            
                ],
                verticalButtons: true,
            }).open();            
        },            
        // atualizarCEP: function(val) {
        //     var self    = this;
        //     if (val) {
        //         if (val.length == 9) {
        //             axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
        //             .then(response => {
        //                 if (response.data) {
        //                     if (response.data.logradouro) {
        //                         self.formEndereco.endereco  = response.data.logradouro;
        //                         self.formEndereco.bairro    = response.data.bairro;
        //                         self.formEndereco.cidade    = response.data.localidade;
        //                         self.formEndereco.estado    = response.data.uf;
        //                         self.$forceUpdate();
        //                     }
        //                 }
        //             })
        //             .catch(error => {
        //             });
        //         }
        //     }
        // },                    
        scrollTop: function() {
            setTimeout(function() {
                $(".page-content")[0].scrollTo({
                    top:    0
                });     
            }, 100);
        },         
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;
            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
                console.log("fez parse", data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },
        redirect: function(route) {
            console.log("app.redirect()", route)
            var self = this;
            self.$router.push({ 
                path:       route
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },                  
        sequence: function(tasks, fn) {
            console.log("sequence()", tasks, fn)
            return tasks.reduce((promise, task) => promise.then(() => fn(task)), Promise.resolve());
        },    
        beep: function() {
            var self = this;
            var audio = new Audio('/static/beep1.mp3');   
            audio.play();
            if (window.cordova) {
                navigator.notification.beep(1);
            }

        },                          
        setUser: function(usuario) {
            var self    = this;
            return new Promise(function(resolve, reject) {
                window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                self.logged    = true;
                self.user   = usuario;

                // self.formEndereco = {
                //     "_cod":             usuario.cod,
                //     "_token":           usuario.token,
                //     "acao":             "endereco",                
                //     "cod":              usuario.enderecoCod,
                //     "cep":              usuario.cep,
                //     "endereco":         usuario.endereco,
                //     "complemento":      usuario.complemento,
                //     "numero":           usuario.numero,
                //     "bairro":           usuario.bairro,
                //     "cidade":           usuario.cidade,
                //     "estado":           usuario.estado,
                // }         

                // if (usuario.tipo == "contratante" && !usuario.cep && !usuario.endereco) {
                //     self.openModalEndereco(true);
                // }          
                resolve(usuario);

            });
        },
        getConfig: function(force) {
            var self        = this;
            console.log("getConfig()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         "configuracoes"
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getConfig() response", response);

                    var diff    = false;
                    if (JSON.stringify(response.data.result.objeto) != JSON.stringify(self.config["configuracoes"])) {
                        diff    = true;
                    }

                    self.config["configuracoes"] = response.data.result.objeto; 
                    setTimeout(function() {
                        self.$forceUpdate();
                        if (diff) {
                            // window.mmenuInit(true);
                        }
                    }, 100);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getConfig() error", error);
                    reject(error);
                    
                });   
            });   
        },                    
        getUser: function(force) {
            var self        = this;
            console.log("getUser()");
            return new Promise(function(resolve, reject) {

                self.getConfig();

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUser() response", response);
                    self.setUser(response.data.result);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getUser() error", error);
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.logout();
                        }
                    }
                    
                    reject(error);
                    
                });   
            });   
        },          
        checkLogin: function() {
            var self    = this;
            if (!window.localStorage.getItem("_usuario")) {
                return false;
            } else {
                var usuario = null;
                try {
                    usuario = JSON.parse(window.localStorage.getItem("_usuario"));
                    self.setUser(usuario);
                    self.getUser();
                    return true;
                } catch(err) {
                    console.log("checkLogin() error parse", err);
                    self.logout();
                    return false;
                }
            }
        },
        logout: function() {
            var self = this;
            console.log("logout()")
            loading.show();
            $(".mm-menu").hide();
            $("#mm-blocker").hide();
            window.localStorage.clear();
            setTimeout(function() {
                location.reload();
            }, 1000);
        
        },
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if ($(".tingle-modal--visible")[0]) {
                $(".tingle-modal--visible").hide();
                $(".tingle-modal").removeClass("tingle-modal--visible");
                console.log("back -> Esconde modal")
            } else {
                console.log("back -> Normal")

                if (window.history.length > 3) {
                    // $(".content-load .dashboard-container").fadeOut(100);                
                }

                // if (self.$route.meta.auth == false) {
                //     window.history.go(-3);
                // } else {
                    window.history.back();
                // }
            }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                // $("body").attr("class", "");
                // $("body").addClass("current-page-" + self.$route.name.toLowerCase());            
            }
        },
        addEvents: function() {
            var self = this;
            $("body").on("click", "a[target='_blank']", function(e) {
                console.log("open InAppBrowser", e.currentTarget.href, e);
                if (window.cordova) {
                    e.preventDefault();
                    window.open = cordova.InAppBrowser.open;
                    window.open(e.currentTarget.href, "_system");
                }

            });            
        },        
        // openModalCurriculo: function(descricao) {
        //     var self = this;
        //     console.log("openModalCurriculo()", descricao);
        //     self.curriculo.descricao = descricao;
        //     self.openModal("modal-curriculo");
        // },
        // openModal: function(nome, html) {
        //     var self        = this;

        //     console.log("openModal()", nome)

        //     loading.show();

        //     self.modal[nome]   = new tingle.modal({
        //         footer:         false,
        //         stickyFooter:   false,
        //         closeMethods:   ['overlay', '', 'escape'],
        //         closeLabel:     "",
        //         cssClass:       [(nome), "modal-default"]
        //     });   

        //     setTimeout(function() {
        //         if (!html) {
        //             self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);      
        //         } else {
        //             self.modal[nome].setContent(html);      
        //         }
        //         self.modal[nome].open();
        //         loading.hide();
        //         setTimeout(function() {
        //             $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i class="las la-times"></i></a>');    
        //         }, 100);
        //     }, 500);

        // },
        openModal: function (nome, html, termos) {
            var self = this;

            console.log("openModal()", nome)

            self.modal[nome] = new tingle.modal({
                footer: false,
                stickyFooter: false,
                closeMethods: ['', '', ''],
                closeLabel: "",
                cssClass: [(nome), "modal-default"]
            });
            setTimeout(function () {
                if (!html) {
                    self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);
                } else {
                    self.modal[nome].setContent(html);
                }
                self.modal[nome].open();
                loading.hide();
                setTimeout(function () {
                    if (!termos) $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i class="las la-times"></i></a>');
                    if (termos) $("." + nome).append('<div class="termos-button"><button type="button" onclick="window.termos.negar()" class="button color-red negar-button button-fill button-large"><i class="las la-ban"></i> Negar</button><button type="button" onclick="window.termos.aceitar()" class="button color-green aceitar-button button-fill button-large">Aceitar<i class="las la-arrow-right"></i></button></div>');
                }, 100);
            }, 100);


        },        
        clearCache: function() {
            console.log("clearCache()");
            var self = this;
            self.cache = JSON.parse(JSON.stringify(self.cacheDefault));
        },
        getPasso: function() {
            var self = this;
            console.log("getPasso()");
            return new Promise(function(resolve, reject) {

                if (self.user.tipo != "prestador" || self.user.empresaCod) {
                    resolve(null);
                    return false;
                }

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/passos.php", form)
                .then(response => {
                    
                    console.log("getPasso() response", response);
                    if (typeof response.data.result.passo != "undefined") {
                        self.setPasso(response.data.result.passo);
                    }
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getPasso() error", error);
                    reject(error);
                    
                });   
            });   
        },
        setPasso: function(passo) {
            console.log("setPasso()", passo);
            var self = this;

            if (passo == 0) {
                window.___app.dialog.create({
                    title: 'Seja bem vindo(a)',
                    text: 'Olá, tudo bem? 😁<br>Vamos te guiar em <b>3 passos</b> para configurar sua conta e ficar disponível para receber novos agendamentos... vamos lá? ',
                    buttons: [
                        {
                            text: '✅ Ok',
                            onClick: function() {
                                self.setPasso(1);
                            }
                        }                                                 
                    ],
                    verticalButtons: true,
                }).open();   
            }

            if (passo == 1) {
                window.___app.dialog.create({
                    title: '⚠ 1º passo',
                    text: 'Você precisa cadastrar sua conta bancária para poder receber os pagamentos pelos serviços.',
                    buttons: [
                        {
                            text: 'Cadastrar dados bancários',
                            onClick: function() {
                                // self.go('Carteira', JSON.stringify({'tutorial': true}));
                                self.$router.push({
                                    name: 'Carteira',
                                    query: {
                                        "tutorial": true
                                    }
                                });                                
                            }
                        },                                                                                                       
                    ],
                    verticalButtons: true,
                }).open();               
            }

            if (passo == 2 && self.user.empresaCod) {
                window.___app.dialog.create({
                    title: '⚠ 2º passo',
                    text: 'Você precisa cadastrar os serviços que você oferece. Escolha a agenda desejada, toque no botão <b>configurar serviços</b> e depois <b>adicionar novo serviço</b>.',
                    buttons: [
                        {
                            text: 'Ver agendas',
                            onClick: function() {
                                // self.go('Agendas', JSON.stringify({'tutorial': true}));
                                self.$router.push({
                                    name: 'Agendas',
                                    params: {
                                        "tutorial": true
                                    }
                                });                                
                            }
                        },                                                                                                       
                    ],
                    verticalButtons: true,
                }).open();
            }      

            if (passo == 3) {
                window.___app.dialog.create({
                    title: '⚠ 3º passo',
                    text: 'Agora que você configurou os serviços, é hora de cadastrar seus <b>horários de atendimento</b> para cada agenda/modalidade. Escolha a agenda desejada, e toque no botão <b>Configurar horários</b>.',
                    buttons: [
                        {
                            text: 'Ver agendas',
                            onClick: function() {
                                self.$router.push({
                                    name: 'Agendas',
                                    params: {
                                        "tutorial": true
                                    }
                                });                             
                                // self.go('Agendas', JSON.stringify({'tutorial': true}));
                            }
                        },                                                                                                       
                    ],
                    verticalButtons: true,
                }).open();               
            }   

            if (passo == 4) {
                window.___app.dialog.create({
                    title: 'Parabéns! 👏😁',
                    text: 'Você completou todos os passos, e já está visível para agendamentos no aplicativo.<br>Qualquer nova movimentação você será notificado. Bom trabalho!',
                    buttons: [
                        {
                            text: '✅ Ok',
                            onClick: function() {
                                
                                loading.show();
                                // faz update do tutorial = 1
                                var form = {
                                    "_cod":         self.user.cod, 
                                    "_token":       self.user.token
                                };

                                axios.put("api/passos.php", form)
                                .then(response => {
                                  
                                    console.log("ok", response.data.result)
                                    loading.hide();
                                    self.go('Inicio');
                                    
                                })
                                .catch(error => {
                                    loading.hide();
                                   
                                    alert(error.response.data.message || "Erro! Por favor, tente novamente.");
                                });
                            }
                        },                                                                                                       
                    ],
                    verticalButtons: true,
                }).open();               
            }            
        }            
    },
    created: function() {
        var self = this;
        self.cache = JSON.parse(JSON.stringify(self.cacheDefault));

        window.__app    = self;

        
        if (!window.cordova) {
            setTimeout(function() {
                // console.log("Force onDeviceReady")
                self.ready = true;
                self.$forceUpdate();
            }, 5000)
        }

        self.initialize();  
        loading.show();
        self.addEvents();


        setTimeout(function() {
            window.___app = new Framework7({
                el: '#app',
                theme: "ios",
                statusbar: {
                    enabled: false
                },
                view: {
                    pushState: false,
                    pushStateSeparator:"",
                    pushStateOnLoad:true
                },
                routes: [],
                popup:{
                    closeOnEscape: true,
                },
                sheet: {
                    closeOnEscape: true,
                },
                popover: {
                    closeOnEscape: true,
                },
                actions: {
                    closeOnEscape: true,
                }
            });
            console.log("Inicializou F7", window.___app);

            window.alert = function(text) {
                window.___app.dialog.alert(text, "");
            }

        }, 1000);
        
    },
    mounted: function() {
        console.log("mounted geral >>");
        var self = this;
        setTimeout(function() {


        }, 1000);
    },
    watch:{
        "formEndereco.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },     
        $route (to, from){
            var self = this;
            self.fixClass();
            setTimeout(function() {
                // window.fixHeight();
                window.scrollTo({
                    top: 0
                });
                
                gtag('config', self.config.googleAnalytics.id, {'page_title': to.meta.title});                 
                
                if (self.logged) {
                    self.getUser();
                }


            }, 100);
        }
    },
    on: {
    }       
})



// WEBPACK FOOTER //
// ./src/main.js